import React, { useEffect, useState } from "react";
import Header from "../../../components/header/Header";
import Footer from "../../../components/footer/Footer";
import { getfeedbackList } from "../../../api/apiHandler";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
const FeedbackList = () => {
  const navigate = useNavigate();
  const [pageNo, setPageNo] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [lsit, setList] = useState([]);
  const [totalRecordCount, setTotalRecordCount] = useState(0);
  const handlePageClick = (event) => {
    setPageNo(event.selected + 1);
  };

  const handleNewFeedback = () => {
    navigate(`/doctor/newfeedback`);
  };

  console.log(lsit, pageNo, "lsitlsitlsit");
  const handleNavigate = (id) => {
    navigate(`/doctor/feedbackdetail/${id}`);
  };

  useEffect(() => {
    Swal.fire({
      title: "Please wait...",
      didOpen: () => {
        Swal.showLoading();
      },
    });
    getfeedbackList({ page: pageNo, record_count: perPage }).then((res) => {
      Swal.close();
      var response = JSON.parse(res);
      console.log("response=>", response);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        setList(response.data.data);
        setTotalRecordCount(Math.ceil(response.data.totalCount / perPage));
      } else {
        console.log("error-->");
      }
    });
  }, [pageNo, perPage]);

  return (
    <>
      <main className="bg-color">
        <Header />
        <section className="doctorsec-pad share-medical">
          <div className="container">
            <div>
              <p className="font_22 font_600 mb-0">My Feedback Records</p>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/" className="font_14">
                      Home
                    </Link>
                  </li>
                  <li
                    className="breadcrumb-item active font_14"
                    aria-current="page"
                  >
                    My Feedback Records
                  </li>
                </ol>
              </nav>
            </div>
            <div className="card">
              <div className="card-body doctor-table-card">
                <div className="search-bar d-flex justify-content-end header-nav bg-transparent"
                style={{boxShadow: "unset"}}>
                  <button
                    className="logout-btn"
                    style={{ fontSize: 17, height: 50, whiteSpace: "nowrap" }}
                    onClick={handleNewFeedback}
                  >
                    Get New Feedback Form
                  </button>
                </div>
                <div className="table-responsive">
                  <table
                    id="mangeUser"
                    className="table table-hover dataTable js-exportable"
                  >
                    <thead>
                      <tr>
                        <th>Feedback Id</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {lsit &&
                        lsit.map((item, index) => {
                          return (
                            <tr id={item.id} key={index}>
                              <td>
                                <h3 className="doc-details">
                                  {/* {item.first_name} {item.middle_name} {item.last_name} */}
                                  {item.id}
                                </h3>
                              </td>
                              <td>
                                {item.first_name} {item.middle_name}{" "}
                                {item.last_name}
                              </td>
                              <td>{item.email1}</td>
                              <td>{item.feedbackStatus}</td>
                              <td>
                                <button
                                  className="connect-btn w-fit-content"
                                  onClick={() => handleNavigate(item?.id)}
                                >
                                  View
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel=" > "
                    onPageChange={handlePageClick}
                    pageCount={totalRecordCount}
                    previousLabel=" < "
                    renderOnZeroPageCount={null}
                    containerClassName="pagination"
                    pageLinkClassName="page-link"
                    previousLinkClassName="page-link"
                    nextLinkClassName="page-link"
                    disabledClassName="disabled"
                    activeClassName="active"
                    activeLinkClassName="active-link"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </main>
    </>
  );
};
export default FeedbackList;
